import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { switchTab } from '../../store/reducers/tabsReducer';
import { selectAllTabs, selectActiveTabId } from '../../store/selectors/tabSelectors';
import { useLanguage } from '../../hooks/useLanguage';

const TabBar = memo(({ isSpanish }) => {
  const dispatch = useDispatch();
  const tabs = useSelector(selectAllTabs);
  const activeTabId = useSelector(selectActiveTabId);

  // Show all tabs, even without data (for multiple tabs logic)
  if (!tabs || tabs.length === 0) {
    return null;
  }

  // Determine if "All" view is active (when activeTabId is null)
  const isAllView = activeTabId === null;

  const handleAllClick = () => {
    // Set activeTabId to null to show all tabs
    dispatch(switchTab(null));
  };

  const handleTabClick = (tabId) => {
    dispatch(switchTab(tabId));
  };

  return (
    <div className="pt-2 mt-4 overflow-x-auto mb-4">
      <div className="flex gap-2 items-center pb-2">
        {/* "All" tab button - shown first, default active */}
        <div
          className={`flex items-center gap-1 rounded-full text-sm cursor-pointer hover:opacity-75 transition-opacity py-1 whitespace-nowrap flex-shrink-0 ${
            isAllView
              ? 'bg-secondary font-semibold px-4'
              : 'px-2 hover:bg-gray-100'
          }`}
          onClick={handleAllClick}
        >
          <span>
            {isSpanish ? 'Todos' : 'All'}
          </span>
        </div>

        {/* Individual tab buttons */}
        {tabs.map((tab) => {
          const isActive = activeTabId === tab.tabId;

          return (
            <div
              key={tab.tabId}
              className={`flex items-center gap-1 rounded-full text-sm cursor-pointer hover:opacity-75 transition-opacity py-1 whitespace-nowrap flex-shrink-0 ${
                isActive
                  ? 'bg-secondary font-semibold px-4'
                  : 'px-2 hover:bg-gray-100'
              }`}
              onClick={() => handleTabClick(tab.tabId)}
            >
              <span>
                {tab.label || (isSpanish ? `Exportación #${tab.declarationIndex + 1}` : `Export #${tab.declarationIndex + 1}`)}
                {tab.isDirty && (
                  <span className="ml-1 text-xs">*</span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
});

TabBar.displayName = 'TabBar';

export default TabBar;

